// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "main.app" + "." + "f7f88f48" + ".chunk.css";
};